import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Newspaper, Download, ExternalLink } from 'lucide-react';
export function PressPage() {
  const pressReleases = [{
    id: 1,
    title: 'Citiplots Raises $10M Series A to Revolutionize Indian Real Estate',
    date: '2024-01-20',
    excerpt: 'Leading proptech startup secures funding from prominent VCs to expand direct plot transaction platform across India.',
    pdf: '/press/series-a-announcement.pdf'
  }, {
    id: 2,
    title: 'Citiplots Partners with 15 State Governments for Auction Listings',
    date: '2024-01-10',
    excerpt: 'Platform becomes official partner for government land auctions, bringing transparency to public property sales.',
    pdf: '/press/govt-partnership.pdf'
  }, {
    id: 3,
    title: 'Citiplots Crosses 50,000 Active Users Milestone',
    date: '2023-12-15',
    excerpt: 'Platform sees 300% growth in user base as direct plot transactions gain popularity among Indian buyers.',
    pdf: '/press/user-milestone.pdf'
  }];
  const mediaKit = [{
    name: 'Company Logo (PNG)',
    size: '2.5 MB',
    file: '/media/logo.png'
  }, {
    name: 'Company Logo (SVG)',
    size: '150 KB',
    file: '/media/logo.svg'
  }, {
    name: 'Brand Guidelines',
    size: '5.2 MB',
    file: '/media/brand-guidelines.pdf'
  }, {
    name: 'Product Screenshots',
    size: '12 MB',
    file: '/media/screenshots.zip'
  }, {
    name: 'Executive Photos',
    size: '8 MB',
    file: '/media/exec-photos.zip'
  }];
  const mediaContact = {
    name: 'Priya Sharma',
    title: 'Head of Communications',
    email: 'press@citiplots.com',
    phone: '+91 123 456 7890'
  };
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-5189">
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-5190">
        <Link to="/" className="flex items-center gap-2" data-id="element-5191">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-5192"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-5193">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="flex-1 max-w-4xl mx-auto px-6 py-12" data-id="element-5194">
        <h1 className="text-4xl font-bold mb-4" data-id="element-5195">Press & Media</h1>
        <p className="text-lg text-gray-500 mb-12 font-mono" data-id="element-5196">
          Latest news, press releases, and media resources
        </p>

        {/* Press Releases */}
        <div className="bg-white border border-gray-300 p-8 mb-8" data-id="element-5197">
          <h2 className="text-2xl font-bold mb-6 flex items-center gap-2" data-id="element-5198">
            <Newspaper className="w-6 h-6" data-id="element-5199" />
            Press Releases
          </h2>
          <div className="space-y-6" data-id="element-5200">
            {pressReleases.map(release => <div key={release.id} className="border-b border-gray-200 pb-6 last:border-0" data-id="element-5201">
                <div className="flex items-start justify-between mb-2" data-id="element-5202">
                  <h3 className="font-bold text-lg flex-1" data-id="element-5203">{release.title}</h3>
                  <span className="text-xs text-gray-500 font-mono" data-id="element-5204">
                    {release.date}
                  </span>
                </div>
                <p className="text-sm text-gray-600 mb-3" data-id="element-5205">{release.excerpt}</p>
                <div className="flex gap-3" data-id="element-5206">
                  <button className="flex items-center gap-2 text-sm font-bold text-blue-600 hover:text-blue-800" data-id="element-5207">
                    <Download className="w-4 h-4" data-id="element-5208" />
                    Download PDF
                  </button>
                  <button className="flex items-center gap-2 text-sm font-bold text-blue-600 hover:text-blue-800" data-id="element-5209">
                    <ExternalLink className="w-4 h-4" data-id="element-5210" />
                    Read Full Story
                  </button>
                </div>
              </div>)}
          </div>
        </div>

        {/* Media Kit */}
        <div className="bg-white border border-gray-300 p-8 mb-8" data-id="element-5211">
          <h2 className="text-2xl font-bold mb-6" data-id="element-5212">Media Kit</h2>
          <p className="text-sm text-gray-600 mb-6" data-id="element-5213">
            Download our brand assets, logos, and product screenshots for media
            coverage
          </p>
          <div className="space-y-3" data-id="element-5214">
            {mediaKit.map((item, i) => <div key={i} className="flex items-center justify-between p-4 border border-gray-200 hover:bg-gray-50" data-id="element-5215">
                <div data-id="element-5216">
                  <p className="font-bold text-sm" data-id="element-5217">{item.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-5218">{item.size}</p>
                </div>
                <button className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-white flex items-center gap-2" data-id="element-5219">
                  <Download className="w-4 h-4" data-id="element-5220" />
                  Download
                </button>
              </div>)}
          </div>
          <button className="w-full mt-4 py-3 bg-[#1f2933] text-white font-bold hover:bg-gray-800" data-id="element-5221">
            Download Complete Media Kit (ZIP)
          </button>
        </div>

        {/* Media Contact */}
        <div className="bg-white border border-gray-300 p-8" data-id="element-5222">
          <h2 className="text-2xl font-bold mb-6" data-id="element-5223">Media Contact</h2>
          <div className="space-y-3" data-id="element-5224">
            <div data-id="element-5225">
              <p className="text-sm text-gray-500" data-id="element-5226">Name</p>
              <p className="font-bold" data-id="element-5227">{mediaContact.name}</p>
            </div>
            <div data-id="element-5228">
              <p className="text-sm text-gray-500" data-id="element-5229">Title</p>
              <p className="font-bold" data-id="element-5230">{mediaContact.title}</p>
            </div>
            <div data-id="element-5231">
              <p className="text-sm text-gray-500" data-id="element-5232">Email</p>
              <a href={`mailto:${mediaContact.email}`} className="font-bold text-blue-600 hover:underline" data-id="element-5233">
                {mediaContact.email}
              </a>
            </div>
            <div data-id="element-5234">
              <p className="text-sm text-gray-500" data-id="element-5235">Phone</p>
              <a href={`tel:${mediaContact.phone}`} className="font-bold text-blue-600 hover:underline" data-id="element-5236">
                {mediaContact.phone}
              </a>
            </div>
          </div>
        </div>

        {/* Featured In */}
        <div className="mt-8 bg-white border border-gray-300 p-8" data-id="element-5237">
          <h3 className="text-xl font-bold mb-6 text-center" data-id="element-5238">As Featured In</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-5239">
            {['TechCrunch', 'Economic Times', 'YourStory', 'Inc42'].map((pub, i) => <div key={i} className="aspect-video bg-gray-100 border border-gray-200 flex items-center justify-center text-gray-400 font-mono text-sm" data-id="element-5240">
                  [{pub}]
                </div>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-5241" />
    </div>;
}